export default "__VITE_PUBLIC_ASSET__56dec95d__"